import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { BackgroundColors, TextColors } from '@picsart/design-system/foundation/colors';

const useStyles = createUseStyles(
  () => ({
    root: {
      position: 'relative',
    },
    emptyItem: {
      height: 44,
      borderBottom: `1px solid ${BackgroundColors.tint2}`,
    },
    container: {},
    calculateSelectWrapper: {
      position: 'absolute',
      top: 0,
      right: 22,
    },
    calculateSelect: {
      height: 40,
      width: 88,
    },
    tableRow: {
      display: 'flex',
    },
    headerCol1: {
      flex: 1,
    },
    headerCol2: {
      flex: 2,
    },
    leftRadius: {
      borderBottomLeftRadius: 6,
    },
    rightRadius: {
      borderBottomRightRadius: 6,
    },
    headerColItem: {
      padding: [Spacings.s12, Spacings.s0],
      borderBottom: `1px solid ${BackgroundColors.tint2}`,
    },
    flexCenter: {},
    flexRight: {
      display: 'flex',
      justifyContent: 'right',
    },
    calculateHeader: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: `2px solid ${BackgroundColors.tint2}`,
      borderBottomLeftRadius: 6,
      borderBottomRightRadius: 6,
      paddingBottom: Spacings.s8,
      '& h4': {
        color: TextColors.tint2,
        height: 40,
        display: 'flex',
        alignItems: 'center',
      },
    },
    calculateItem: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14,
      width: '100%',
      '& div': {
        borderBottom: `1px solid ${BackgroundColors.tint2}`,
        paddingBottom: Spacings.s12,
      },
    },
  }),
  {
    name: 'size-calculate',
  },
);

export default useStyles;
